document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.card__color-swatches').forEach(swatchList => {
    const card = swatchList.closest('.card-wrapper-swach');
    if (!card) return;

    const media = card.querySelector('.card__media');
    const img   = media.querySelector('img.card__media-image');
    let defaultSrc = media.dataset.defaultImage || img.src;

    // プリロード
    swatchList.querySelectorAll('.swatch-item').forEach(swatch => {
      const url = swatch.dataset.imageUrl;
      if (url) new Image().src = url;
    });

    swatchList.querySelectorAll('.swatch-item').forEach(swatch => {
      const url = swatch.dataset.imageUrl || defaultSrc;

      swatch.addEventListener('mouseenter', () => img.src = url);
      swatch.addEventListener('mouseleave', () => img.src = defaultSrc);

      swatch.addEventListener('click', () => {
        // 1) 画像切り替え
        defaultSrc = url;
        img.src    = url;

        // 2) 選択クラス付け替え（クリックされたものだけ selected）
        swatchList.querySelectorAll('.swatch-item')
          .forEach(s => s.classList.remove('selected'));
        swatch.classList.add('selected');
      });
    });

    // —— 初期選択ロジックは削除 —— 
  });
});
